import React, { useState } from 'react'
import Classes from '../MainLayout.module.css'
import ProfileDropDown from '../ProfileDropDown'
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Notifications from '../../../GlobalComponents/Notification/Notifcation';
import { useSelector } from 'react-redux';

const MenuIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height='20px' viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" /></svg>
)

export default function Header({ setopenMobileSidebar, isMobile }) {
    const location = useLocation();
    const navigateTo = useNavigate();
    const [activePage, setActivePage] = useState(location.pathname);
    const { user } = useSelector((s) => s.auth);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    function formatPageTitle(pathname) {
        if (pathname === '/') return 'Dashboard';
        if (pathname === '/dashboard') return 'Dashboard';
        if (pathname === '/messages') return 'Messages';
        if (pathname === '/services') return 'Services';
        if (pathname === '/appointments') return 'Appointments';
        if (pathname === '/invoices') return 'Invoices';
        if (pathname === '/settings') return 'Settings';
        return '';
    }

    return (
        <>
            <header className={Classes.navbar}  >
                {isMobile ?
                    <div onClick={() => { setopenMobileSidebar(true) }} className='flexAlign10' >
                        <div className='flex' > <MenuIcon /> </div>
                        <h4 className={Classes.headTitle} > {formatPageTitle(location?.pathname)} </h4>
                    </div>
                    :
                    <>
                        {activePage === '/' ?
                            <div> <h5>Welcome to Fuel Clubs!</h5> </div>
                            : <div></div>
                        }
                    </>
                }

                <div className={Classes.headerRight} >
                    <div className={Classes.tooltipCon} onClick={() => { navigateTo('/contact-us') }} >
                        <div className={Classes.tooltipHead}> <h5>?</h5> </div>
                    </div>
                    <Notifications />
                    {/* <div className={Classes.verticleLine} ></div>
                    <div className={Classes.profileSection}>
                        <ProfileDropDown />
                    </div> */}
                </div>
            </header>
        </>
    )
}
